import { AppActions } from './action-types';

const appMounted = () => ({
  type: AppActions.APP_MOUNTED,
});

const appAuthReset = () => ({
  type: AppActions.APP_AUTH_RESET,
});

const appSignOut = () => ({
  type: AppActions.APP_SIGN_OUT,
});

const fetchTranslations = (locale) => ({
  type: AppActions.FETCH_TRANSLATIONS,
  payload: locale,
});

const validateAuthToken = () => ({
  type: AppActions.VALIDATE_AUTH_TOKEN,
});

export {
  appMounted,
  appAuthReset,
  appSignOut,
  fetchTranslations,
  validateAuthToken,
};
